export default __webpack_public_path__ + "static/media/hobbit.81b23312.png";